/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS,
  LOAD_EMPLOYEE_LEAVE_RECORD_ERROR,
  LOAD_EMPLOYEE_LIST_SUCCESS,
  LOAD_EMPLOYEE_LIST_ERROR,
  LOAD_EMPLOYEE_DROPDOWN_SUCCESS,
  LOAD_EMPLOYEE_DROPDOWN_ERROR,
  LOAD_DOCUMENT_SUCCESS,
  LOAD_DOCUMENT_ERROR,
  LOAD_ATTENDANCE_VIEW_SUCCESS,
  LOAD_ATTENDANCE_VIEW_ERROR,
  LOAD_PROJECT_LIST_SUCCESS,
  LOAD_PROJECT_LIST_ERROR,
} from "./constants";

const initialState = {
  employeeLeaveRecord_list: [],
  employee_list: {},
  documentList: {},
  attendanceViewList: {},
  projectlist:[],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
  dropDownList: {},
};

const Reducer = (
  state = initialState,
  { type, employeeLeaveRecord_list, employee_list, dropDownList, error,documentList,attendanceViewList,projectlist}
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS:
        draft.employeeLeaveRecord_list = employeeLeaveRecord_list;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_EMPLOYEE_LIST_SUCCESS:
        draft.employee_list = employee_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EMPLOYEE_DROPDOWN_SUCCESS:
        draft.dropDownList = dropDownList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DOCUMENT_SUCCESS:
        draft.documentList = documentList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ATTENDANCE_VIEW_SUCCESS:
        draft.attendanceViewList = attendanceViewList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EMPLOYEE_DROPDOWN_ERROR:
      case LOAD_ATTENDANCE_VIEW_ERROR:
      case LOAD_EMPLOYEE_LEAVE_RECORD_ERROR:
      case LOAD_PROJECT_LIST_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      case LOAD_PROJECT_LIST_SUCCESS:
        draft.projectlist = projectlist;
        draft.success = true;
        draft.error = false;
        break;
      case LOAD_EMPLOYEE_LIST_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      case LOAD_DOCUMENT_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
